"use strict"

const axios = require('axios')

const URL = "https://www.googleapis.com/calendar/v3/calendars/{calendarId}/events?orderBy=startTime&singleEvents=true&timeMin={ymdString}T00%3A00%3A00Z&key={apiKey}&maxResults={limit}"

export default class GoogleCalendar {

    constructor(data) {
    
        if (data) {
            this.id = data['id']
            this.summary = data['summary']
            this.location = data['location']
            this.startDateTime = data['start']['dateTime']
            this.endDateTime = data['end']['dateTime']
        }
        else {
            this.id = null
            this.summary = null
            this.location = null
            this.startDateTime = null
            this.endDateTime = null
        }
    }


    static request(calendarId, apiKey, limit = 10) {
        var now = new Date()
        var ymdString = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate()
        var url = URL.replace(/\{calendarId\}/, calendarId)
        url = url.replace(/\{apiKey\}/, apiKey)
        url = url.replace(/\{ymdString\}/, ymdString)
        url = url.replace(/\{limit\}/, limit)
        console.debug('url : ' + url)

        return new Promise(function(solved, reject) {
            axios.get(url)
            .then(function (response) {
                solved(response.data)
            })
            .catch(function (error) {
                if (error.response) {
                    reject(error.response.status, error.message)
                }
                else if (error.request) {
                    reject(-1, error.message)
                }
                else {
                    reject(-1, error.message)
                }
            })
        })
    }


    /**
     * @param {array} data GoogleCalendar から取得したJSONオブジェクト 
     * @return GoogleCalendarオブジェクト
     */
    static convertCalendarList(data) {
        var items = data['items']
        var calendars = []

        for (var i in items) {
            calendars.push(new GoogleCalendar(items[i]))
        }

        return calendars
    }
}